import { isPlanExists } from '@db/Plans/Check';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db, { parseFirestoreDoc } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Comment } from '@types';

export function parseComment(doc: db.DocumentSnapshot) {
  return parseFirestoreDoc<Comment>(doc, 'commentId');
}

export async function addComment(comment: string, planId: string) {
  const currentUserId = getCurrentUserId();
  const exists = await isPlanExists(planId);
  if (!exists) {
    throw Error('Cant add comment because plan doesnt exist. planId=' + planId);
  }
  await db.addDoc(db.collection(firestore, 'plans', planId, 'comments'), {
    createdAt: db.serverTimestamp(),
    comment,
    userId: currentUserId,
  });
}

export async function deleteComment(planId: string, commentId: string) {
  await db.deleteDoc(db.doc(firestore, 'plans', planId, 'comments', commentId));
}

export async function updateComment(comment: string, planId: string, commentId: string) {
  await db.updateDoc(db.doc(firestore, 'plans', planId, 'comments', commentId), {
    updatedAt: db.serverTimestamp(),
    comment,
  });
}

export async function getPlanComments(planId: string) {
  const querySnapshot = await db.getDocs(db.collection(firestore, 'plans', planId, 'comments'));
  return querySnapshot.docs.map((doc) => parseComment(doc));
}
